import { createGlobalStyle } from 'styled-components'
import '../assets/fonts/index.css'

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    font-family: Ubuntu;
    margin: 0;
    padding: 0;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    background-color: #FFF;
  }

  #root {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 100vh;
  }

  main {
    flex: 1;
  }

  a {
    text-decoration: none;
  }

  figure {
    line-height: 0;
    max-width: fit-content;

    img {
      width: 100%;
    }
  }
`

export default GlobalStyle
